import { Controller } from "@hotwired/stimulus";

/**
 * ダウンロードの重複実行を抑止する
 * @example
 * <div data-controller="download-once">
 * <a data-download-once-target="link" data-action="click->download-once#click">ダウンロード</a>
 * <p data-download-once-target="note" hidden>ダウンロードを開始しました。</p>
 */
export default class DownloadOnceController extends Controller {
  static targets = ["link", "note"];

  connect() {
    this.disabled = false;
    this.linkTarget.removeAttribute("aria-disabled");
    if (this.hasNoteTarget) this.noteTarget.hidden = true;
  }

  click(e) {
    if (this.disabled) {
      e.preventDefault();
      return;
    }

    this.disabled = true;
    // common.js が [aria-disabled='true'] のクリックを打ち消すため、次のタスクで付与する
    setTimeout(() => this.disable(), 0);
  }

  disable() {
    this.linkTarget.setAttribute("aria-disabled", "true");
    if (this.hasNoteTarget) this.noteTarget.hidden = false;
  }
}
